import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getAllStages } from '@/actions/stages/getAllStages';
import { ApiResponse } from '@/types/response.type';
import { Stage } from '@/types/stage.type';

export interface UseGetAllStagesReturn {
  result: ApiResponse<Array<Stage>> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetAllStages = (): UseGetAllStagesReturn => {
  const query: UseQueryResult<ApiResponse<Array<Stage>>, Error> = useQuery({
    queryKey: ['stages'],
    queryFn: getAllStages,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
